/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { CreateAssetMutation, CreateAssetMutationVariables } from "@models/graphql";

const defaultCreateAssetOptions: MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables> = {};

export const useCreateAsset = (options?: MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<CreateAssetMutation, CreateAssetMutationVariables>(
        GraphQLDocuments.createAsset
    );

    const createAsset = async (variables: CreateAssetMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultCreateAssetOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        createAsset
    };
};
